import { Box, Flex, Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

import { to_currency } from "helpers/number"

import Affirm from "./affirm"
import { PlanTitle } from "./component"
import Klarna from "./klarna"

const TitleBlock = styled(Box).attrs((props) => ({
  mx: { _: "29px", desktop: "auto" },
  ...props.theme.info.titleBlock,
}))``

const KlarnaAffirm = () => {
  const paymentPrices = {
    affirmOrderMin: to_currency(249.99, { precision: 2 }),
    klarnaFinancingRate: to_currency(210.67, { precision: 2 }),
    klarnaMin: to_currency(35),
    klarnaOrderMin: to_currency(149),
    orderMin: to_currency(150),
    simpleFinancing: to_currency(1264),
    simpleFinancingRate: to_currency(421.33, { precision: 2 }),
    splitPay: to_currency(200),
    splitPayRate: to_currency(50),
  }

  return (
    <>
      <Box contain mb="120px" textAlign="center">
        <TitleBlock>
          <PlanTitle>Payment Plans</PlanTitle>
          <Typography
            fontSize="22px"
            fontWeight="400"
            lineHeight="33.8px"
            mb={3}
          >
            Made For You
          </Typography>

          <Typography
            lineHeight="20px"
            mx="auto"
            width={{ _: "auto", desktop: "402px" }}
          >
            {sl.config.site_title} has partnered with Affirm and Klarna to offer
            a choice of payment options perfect for you.
          </Typography>
        </TitleBlock>
        <Flex
          flexDirection={{ _: "column", desktop: "row" }}
          justifyContent="center"
        >
          <Affirm paymentPrices={paymentPrices} />
          <Klarna paymentPrices={paymentPrices} />
        </Flex>
      </Box>
    </>
  )
}

export default KlarnaAffirm
